export const PROPERTIES_OUTPUTS_DEBOUNCE_NUMBER = 300;


// WEBPACK FOOTER //
// ./source/ts/constants/debounce.ts